import { AddCircle, RemoveCircle } from 'emotion-icons/material'
import React, { useRef } from 'react'
import { ACCORDION } from '../../utils/dataTrackingValues'
import Typography from '../Typography'
import * as Styled from './Accordion.styles'

const AccordionItem = ({
  item = { title: '', content: '' },
  index,
  isOpen,
  handleOpen,
  requestId,
}) => {
  const { title, content } = item
  const ItemsWrapperRef = useRef()

  const ArrowNavigation = (event) => {
    const { keyCode } = event
    let direction

    switch (keyCode) {
      // ArrowUp
      case 38:
        direction = 'previousSibling'
        break

      // ArrowDown
      case 40:
        direction = 'nextSibling'
        break

      // Space Character
      case 32:
        // Prevents the page from scrolling when they hit the spacebar to open the accordion item
        event.preventDefault()
        break

      default:
        direction = null
    }

    const elementToFocus = ItemsWrapperRef?.current?.[direction]?.firstChild
    if (typeof elementToFocus !== 'undefined' && elementToFocus !== null) {
      elementToFocus.focus()
    }
  }

  const handleClick = (event, question) => {
    if (
      event.type === 'click' ||
      (event.type === 'keydown' &&
        (event.key === 'Enter' || event.keyCode === 32))
    ) {
      handleOpen(index)
    }

    // Allows users to navigate through the items with up/down arrows
    ArrowNavigation(event)

    ACCORDION.handleClick(question, requestId)
  }

  return (
    <div
      ref={ItemsWrapperRef}
      data-testid={`accordion-item${index}`}
      className="leshen-accordion-item"
    >
      <Styled.ItemHeader
        className="item-header"
        role="button"
        tabIndex="0"
        onClick={(event) => handleClick(event, title, content)}
        onKeyDown={(event) => handleClick(event, title, content)}
      >
        {isOpen ? (
          <RemoveCircle className="remove" />
        ) : (
          <AddCircle className="add" />
        )}
        <Typography className="header-text" variant="feature">
          {title}
        </Typography>
      </Styled.ItemHeader>
      <Styled.ItemContent
        className="item-content"
        isOpen={isOpen}
        data-testid={`accordion-content${index}`}
      >
        {content}
      </Styled.ItemContent>
    </div>
  )
}

export default AccordionItem
